import type { CustomersStore } from './interfaces'

export const actions = {
  setLoading (this: CustomersStore, payload: CustomersStore['loading']): void {
    this.loading = payload
  },
  setCustomers (this: CustomersStore, payload: CustomersStore['customers']): void {
    this.customers = payload
  },
  setMeta (this: CustomersStore, payload: CustomersStore['meta']): void {
    this.meta = payload
  },
  setFilterSearch (this: CustomersStore, payload: CustomersStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterStatus (this: CustomersStore, payload: CustomersStore['filterStatus']): void {
    this.filterStatus = payload
  },
  setFilterStages (this: CustomersStore, payload: CustomersStore['filterStages']): void {
    this.filterStages = payload
  },
  setFilterFrom (this: CustomersStore, payload: CustomersStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: CustomersStore, payload: CustomersStore['filterTo']): void {
    this.filterTo = payload
  },
  setFilterSourceFunnel (this: CustomersStore, payload: CustomersStore['filterSourceFunnel']): void {
    this.filterSourceFunnel = payload
  },
  setFilterTutorId (this: CustomersStore, payload: CustomersStore['filterTutorId']): void {
    this.filterTutorId = payload
  },
  setFilterStudyingStatus (this: CustomersStore, payload: CustomersStore['filterStudyingStatus']): void {
    this.filterStudyingStatus = payload
  },
  setCurrentPage (this: CustomersStore, payload: CustomersStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: CustomersStore, payload: CustomersStore['perPage']): void {
    this.perPage = payload
  },
  setDeleteCustomerId (this: CustomersStore, payload: CustomersStore['deleteCustomerId']): void {
    this.deleteCustomerId = payload
  },
  setDeleting (this: CustomersStore, payload: CustomersStore['deleting']): void {
    this.deleting = payload
  },
  resetFilters (this: CustomersStore): void {
    this.filterSearch = null
    this.filterStatus = null
    this.filterStages = []
    this.filterFrom = null
    this.filterTo = null
    this.filterSourceFunnel = null
    this.filterTutorId = null
    this.filterStudyingStatus = null
    this.currentPage = 1
  },
}
